var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechToSpeechHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.016,
    height: 21.428,
    viewBox: "0 0 23.016 21.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2234",
    "data-name": "Raggruppa 2234",
    transform: "translate(-16548.572 21046.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2223",
    "data-name": "Raggruppa 2223",
    transform: "translate(16516.641 -21541.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3540",
    "data-name": "Tracciato 3540",
    d: "M3.312,16.663a4.831,4.831,0,0,1,0-4.971h0a1.932,1.932,0,0,1,1.278-.9l2.18-.436a.58.58,0,0,0,.332-.2l2.664-3.2c1.523-1.827,2.284-2.741,2.963-2.495s.679,1.435.679,3.813v11.8c0,2.378,0,3.567-.679,3.813s-1.441-.668-2.963-2.495L7.1,18.2A.58.58,0,0,0,6.77,18l-2.18-.436a1.932,1.932,0,0,1-1.278-.9Z",
    transform: "translate(30.376 491.322)",
    fill: "none",
    stroke: "#ffba00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3541",
    "data-name": "Tracciato 3541",
    d: "M15.535,8.464a6.437,6.437,0,0,1,.036,9.068",
    transform: "translate(32.088 492.473)",
    fill: "none",
    stroke: "#ffba00",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3542",
    "data-name": "Tracciato 3542",
    d: "M19.657,6.343a10.3,10.3,0,0,1,.057,14.509",
    transform: "translate(31.273 491.875)",
    fill: "none",
    stroke: "#ffba00",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechToSpeechHome);
export default __webpack_public_path__ + "static/media/speech-to-speech-home.cf789f09a07f4119cfe7957be202b56c.svg";
export { ForwardRef as ReactComponent };